<template>
  <div class="flex flex-wrap col-gap-4 row-gap-4 -mr-4">
    <ButtonGrouped v-for="(value,key) in summary" :key="key"
                   :theme="currentActive === key ? 'default' : 'white'"
                   size="sm"
                   :disabled="value === 0"
                   @click.native="$emit('select',key)">
      <template #left>{{ $t(`buttonLabels.${key}`) }}</template>
      <template #right v-if="value !== 0">{{ value }}</template>
    </ButtonGrouped>
  </div>
</template>

<script>
import ButtonGrouped from "@/components/UI/ButtonGrouped";

export default {
  name: "TrashMenu",
  components: {ButtonGrouped},
  props: {
    summary: {
      type: Object
    },
    currentActive: {
      type: String
    }
  },
  i18n: {
    messages: {
      en: {
        buttonLabels: {
          transactions: 'Transactions',
          accounts: 'Accounts',
          expenseCategories: 'Expense categories',
          incomeSources: 'Income sources',
          contractors: 'Contractors',
          portfolios: 'Investment portfolios',
        }
      },
      ru: {
        buttonLabels: {
          transactions: 'Операции',
          accounts: 'Счета',
          expenseCategories: 'Категории расходов',
          incomeSources: 'Источники доходов',
          contractors: 'Контрагенты',
          portfolios: 'Инвестпортфели',
        }
      }
    }
  }
}
</script>